import { appAlertComponentModule } from '../../app-alert/app-alert';

export const stopRouteChangeIfInvalidComponentModule = angular
  .module('Q.components.forms.stop-route-change-if-invalid', [
    appAlertComponentModule,
  ])

  .factory('showFormError', function (appAlert) {
    return function showFormError(ngForm, event) {
      if (Array.isArray(ngForm)) {
        return ngForm
          .map((form) => showFormError(form, event))
          .some(angular.identity);
      }
      if (ngForm && ngForm.$invalid) {
        if (event) {
          event.preventDefault();
        }
        ngForm.$setSubmitted();
        if (ngForm.scrollToError) {
          ngForm.scrollToError();
        } else {
          appAlert.error('Please fix the marked errors.');
        }
        return true;
      }
    };
  })

  .directive('stopRouteChangeIfInvalid', function (showFormError, $state) {
    return {
      restrict: 'A',
      require: 'form',
      link: function (scope, elem, attrs, ngForm) {
        let userLoggedOut = false;

        function preventDefaultOnInvalid(event, toState) {
          const toStateName = toState && toState.name;
          const fromStateName = $state.current && $state.current.name;
          // Only process if...
          if (
            !userLoggedOut && // still logged in
            !event.defaultPrevented && // not prevented elsewhere
            fromStateName && // not the initial load
            toStateName !== 'error' && // not switching to an error
            toStateName !== fromStateName && // we're actually switching routes
            !scope.$eval(attrs.stopRouteChangeIfInvalid) // not told to ignore
          ) {
            showFormError(ngForm, event);
          }
        }

        scope.$on('warnOnChanges.shouldContinue', preventDefaultOnInvalid);
        scope.$on('$stateChangeStart', preventDefaultOnInvalid);
        scope.$on('app.logout', () => (userLoggedOut = true));
      },
    };
  });
